import InfoFlightUpdate from '@/views/InfoFlightUpdate/index.vue'

const InfoFlightUpdateRouter = {
  path: '/info-flight-update',
  name: 'InfoFlightUpdate',
  component: InfoFlightUpdate,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default InfoFlightUpdateRouter
